// NAVIGATION CONSTANTS

const mainNav = document.getElementById('mainNav');
const subNav = document.getElementById('subNav');
const subGeNav = document.getElementById('subGeNav');
const subBoNav = document.getElementById('subBoNav');
const toggleNav = document.getElementById('toggleNav');
const toggleGeNav = document.getElementById('toggleGeNav');
const toggleBoNav = document.getElementById('toggleBoNav');
const touchHover = document.getElementById('touchHover');
const touchGeHover = document.getElementById('touchGeHover');
const touchBoHover = document.getElementById('touchBoHover');
const clearHover = document.getElementsByClassName('clearhover');

// DESKTOP & TABLET MENU

touchHover.addEventListener('click', (e) => {
    e.preventDefault();
    subNav.classList.toggle('visible');
    toggleNav.classList.toggle('minus');
}, false);

touchGeHover.addEventListener('click', (e) => {
    e.preventDefault();
    subGeNav.classList.toggle('visible');
    toggleGeNav.classList.toggle('minus');
}, false);

touchBoHover.addEventListener('click', (e) => {
    e.preventDefault();
    subBoNav.classList.toggle('visible');
    toggleBoNav.classList.toggle('minus');
}, false);

touchHover.addEventListener('touchstart', (e) => {
    e.preventDefault();
    subNav.classList.toggle('touch-active');
    subNav.classList.toggle('visible');
    toggleNav.classList.toggle('minus');
}, false);

touchGeHover.addEventListener('touchstart', (e) => {
    e.preventDefault();
    subGeNav.classList.toggle('touch-active');
    subGeNav.classList.toggle('visible');
    toggleGeNav.classList.toggle('minus');
}, false);

touchBoHover.addEventListener('touchstart', (e) => {
    e.preventDefault();
    subBoNav.classList.toggle('touch-active');
    subBoNav.classList.toggle('visible');
    toggleBoNav.classList.toggle('minus');
}, false);

[...clearHover].forEach((link) => {
    link.addEventListener('focus', () => {
        subNav.classList.remove('touch-active');
        subGeNav.classList.remove('touch-active');
        subBoNav.classList.remove('touch-active');
        subNav.classList.remove('visible');
        subGeNav.classList.remove('visible');
        subBoNav.classList.remove('visible');
    });
});

// MOBILE MENU

function toggleMain(e) {
    mainNav.classList.toggle('arrowup');
    subNav.classList.remove('visible');
    subGeNav.classList.remove('visible');
    subBoNav.classList.remove('visible');
    toggleNav.classList.remove('minus');
    toggleGeNav.classList.remove('minus');
    toggleBoNav.classList.remove('minus');
}

mainNav.addEventListener('click', toggleMain);

// SUB NAVIGATION

function toggleSubNav(e) {
    e.preventDefault();
    document.getElementById(this.href.split('#')[1]).classList.toggle('visible');
    this.classList.toggle('minus');
}

[...document.getElementsByClassName('nav-toggle--sub')].forEach((toggle) => {
    toggle.addEventListener('click', toggleSubNav);
});

// MAPS

async function initMap() {
    const destinationLocation = new google.maps.LatLng(41.124129, -85.213024);
    const mapCanvas = document.getElementById('map');
    const map = new google.maps.Map(mapCanvas, {
        zoom: 13,
        center: destinationLocation,
        scrollwheel: false,
        disableDefaultUI: true,
        zoomControl: true,
        zoomControlOptions: {
            position: google.maps.ControlPosition.RIGHT_TOP,
        },
        mapTypeControl: false,
        scaleControl: true,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: true,
        mapId: mapCanvas.dataset.mapid ?? '',
    });

    function calculateCenter() {
        return map.getCenter();
    }

    const icon = document.createElement('img');
    icon.src = 'https://media.sweetwater.com/about/images/sw_map_marker_drk.svg';

    // Destination marker
    const { AdvancedMarkerElement } = await google.maps.importLibrary('marker');
    var destinationMarker = new AdvancedMarkerElement({
        position: destinationLocation,
        map: map,
        content: icon,
        title: "Sweetwater"
    });

    //Popup message for icon
    var infowindow = new google.maps.InfoWindow({
        content: "<div class=\"poi-info-window gm-style\"><div class=\"title full-width\">Sweetwater Sound</div><div class=\"address-line full-width\">5501 US-30</div><div class=\"address-line full-width\">Fort Wayne, IN 46818</div><div class=\"view-link\"><a href=\"https://maps.google.com/maps?ll=41.128198,-85.212251&z=14&t=m&hl=en-US&gl=US&mapclient=apiv3&cid=14371540999621760486\"><span>View on Google Maps</span></div></div>"
    });

    //Open popup when icon clicked
    google.maps.event.addListener(destinationMarker, 'click', function() {
        infowindow.open(map,destinationMarker);
     });

    // Add "title" to iframe for ADA compliance
    google.maps.event.addListenerOnce(map, 'idle', () => {
        document.getElementsByTagName('iframe')[0].title = 'Google Maps';
    });

    // Refresh & center map on resize
    google.maps.event.addListener(window, 'resize', () => {
        const center = calculateCenter();
        google.maps.event.trigger(map, 'resize');
        map.setCenter(center);
    });
}

window.initMap = initMap;

document.addEventListener('DOMContentLoaded', () => {
    const mapinfo = document.querySelector('#map');
    const gMapScript = document.createElement('script');
    if (!mapinfo.dataset.mapid) {
        return;
    }
    gMapScript.src = 'https://maps.googleapis.com/maps/api/js?key=' + mapinfo.dataset.mapid + '&libraries=places,marker&callback=initMap&loading=async';
    gMapScript.async = 'true';
    gMapScript.defer = 'true';
    document.body.appendChild(gMapScript);
});

// LIGHTBOXES

const imgActiveClass = 'lightbox--visible';
const focusableSelector = 'a[href], button, textarea, input, select, [tabindex]:not([tabindex="-1"])';
let lastActiveElement = null;

function getFocusables(lightbox) {
    return lightbox.querySelectorAll(focusableSelector);
}

function getOpenLightbox() {
    return document.querySelector(`.${imgActiveClass}`);
}

// Hides the lightbox, unlocks page scroll, and returns focus to the thumb that opend it
function closeLightbox(lightbox) {
    lightbox.classList.remove(imgActiveClass);
    document.documentElement.classList.remove('lightbox-open');
    if (lastActiveElement) {
        lastActiveElement.focus();
        lastActiveElement = null;
    }
}

function lightboxThumbTrigger(e) {
    e.preventDefault();
    lastActiveElement = this;

    const imgId = this.href.split('#')[1];
    const imgWrap = document.getElementById(imgId);
    [...imgWrap.querySelectorAll('source[data-srcset]')].forEach((source) => {
        source.setAttribute('srcset', source.getAttribute('data-srcset'));
        source.removeAttribute('data-srcset');
    });
    [...imgWrap.querySelectorAll('img[data-src]')].forEach((img) => {
        const src = img.getAttribute('data-src');
        const srcset = img.getAttribute('data-srcset');
        img.setAttribute('src', src);
        img.removeAttribute('data-src');
        if (srcset !== null && srcset !== '') {
            img.setAttribute('srcset', srcset);
            img.removeAttribute('data-srcset');
        }
    });
    imgWrap.classList.add(imgActiveClass);
    document.documentElement.classList.add('lightbox-open');
    imgWrap.querySelector('.lightbox-close').focus();
}

function lightboxClose(e) {
    e.preventDefault();
    closeLightbox(this);
}

[...document.getElementsByClassName('lightbox-thumb')].forEach((img) => {
    img.addEventListener('click', lightboxThumbTrigger);
});

[...document.getElementsByClassName('lightbox')].forEach((img) => {
    img.addEventListener('click', lightboxClose);
});

// Escape closes the open lightbox; Tab/Shift Tab keep focus trapped within
document.addEventListener('keydown', (e) => {
    const openLightbox = getOpenLightbox();
    if (!openLightbox) return;

    if (e.key === 'Escape') {
        closeLightbox(openLightbox);
        return;
    }

    if (e.key !== 'Tab') return;

    const focusables = getFocusables(openLightbox);
    const first = focusables[0];
    const last = focusables[focusables.length - 1];
    const focusOutside = !openLightbox.contains(document.activeElement);

    if (e.shiftKey && (focusOutside || document.activeElement === first)) {
        e.preventDefault();
        last.focus();
    } else if (!e.shiftKey && (focusOutside || document.activeElement === last)) {
        e.preventDefault();
        first.focus();
    }
});

// ACCORDION MENU (Gear Exchange)

var classname = document.querySelectorAll(".sweetwater-local__accordion > a");
for (var i = 0; i < classname.length; i++) {
    classname[i].addEventListener('click', function(e){
        e.preventDefault();
        $(this).parent().toggleClass('sweetwater-local__accordion-open');
    }, false);
}

// HOTEL SLIDER (Accessibility page)

const hotelSlider = document.querySelector('.hotel-slider');

if (hotelSlider) {
    const track = hotelSlider.querySelector('.hotel-slider__track');
    const slides = hotelSlider.querySelectorAll('.hotel-slider__slide');
    const prevBtn = hotelSlider.querySelector('.product-suggest__nav--prev');
    const nextBtn = hotelSlider.querySelector('.product-suggest__nav--next');
    const currentEl = hotelSlider.querySelector('.hotel-slider__current');
    const totalEl = hotelSlider.querySelector('.hotel-slider__total');
    const viewport = hotelSlider.querySelector('.hotel-slider__viewport');
    let currentIndex = 0;

    if (totalEl) {
        totalEl.textContent = slides.length;
    }

    function updateControls() {
        if (currentEl) {
            currentEl.textContent = currentIndex + 1;
        }
        if (prevBtn) {
            prevBtn.disabled = currentIndex === 0;
            prevBtn.classList.toggle('disabled', currentIndex === 0);
        }
        if (nextBtn) {
            nextBtn.disabled = currentIndex === slides.length - 1;
            nextBtn.classList.toggle('disabled', currentIndex === slides.length - 1);
        }
    }

    function goToSlide(index) {
        currentIndex = Math.max(0, Math.min(index, slides.length - 1));
        track.scrollTo({
            left: slides[currentIndex].offsetLeft,
            behavior: 'smooth',
        });
        updateControls();
    }

    if (prevBtn) {
        prevBtn.addEventListener('click', () => goToSlide(currentIndex - 1));
    }

    if (nextBtn) {
        nextBtn.addEventListener('click', () => goToSlide(currentIndex + 1));
    }

    track.addEventListener('scroll', () => {
        let closestIndex = 0;
        let closestDistance = Infinity;

        slides.forEach((slide, index) => {
            const distance = Math.abs(slide.offsetLeft - track.scrollLeft);
            if (distance < closestDistance) {
                closestDistance = distance;
                closestIndex = index;
            }
        });

        if (closestIndex !== currentIndex) {
            currentIndex = closestIndex;
            updateControls();
        }
    });

    if (viewport) {
        viewport.addEventListener('keydown', (e) => {
            if (e.key === 'ArrowLeft') {
                e.preventDefault();
                goToSlide(currentIndex - 1);
            } else if (e.key === 'ArrowRight') {
                e.preventDefault();
                goToSlide(currentIndex + 1);
            }
        });
    }

    function setSliderHeight() {
        const slideWidth = viewport.clientWidth;

        slides.forEach((slide) => {
            slide.style.height = 'auto';
            slide.style.width = `${slideWidth}px`;
        });

        const heights = Array.from(slides).map((slide) => slide.offsetHeight);
        const maxHeight = Math.max(...heights);

        slides.forEach((slide) => {
            slide.style.width = '';
            if (maxHeight > 0) {
                slide.style.height = `${maxHeight}px`;
            }
        });
    }


    let sliderResizeTimer;
    function handleSliderResize() {
        clearTimeout(sliderResizeTimer);
        sliderResizeTimer = setTimeout(setSliderHeight, 150);
    }

    updateControls();
    setSliderHeight();
    window.addEventListener('resize', handleSliderResize);
}
